export const CLASSROOM_NAME_MAX_LENGTH = 100;
export const CLASSROOM_MEMBER_DISPLAY_NAME_MAX_LENGTH = 14;

/** 한 학급에 둘 수 있는 최대 학생 수. 백엔드 UserCodeConsts.MAX_STUDENTS_PER_CLASS 와 일치. */
export const MAX_STUDENTS_PER_CLASSROOM = 200;
export const MIN_STUDENTS_PER_CREATE = 1;

/** 학생 코드 생성 수를 1~학급 정원 범위로 맞춘다. */
export const clampStudentCreateCount = (value: number) =>
  Math.min(
    MAX_STUDENTS_PER_CLASSROOM,
    Math.max(MIN_STUDENTS_PER_CREATE, value),
  );

export const validateClassroomName = (name: string) => {
  const trimmed = name.trim();
  return trimmed.length > 0 && trimmed.length <= CLASSROOM_NAME_MAX_LENGTH;
};

export const validateMemberDisplayName = (name: string) => {
  const trimmed = name.trim();
  return (
    trimmed.length > 0 &&
    trimmed.length <= CLASSROOM_MEMBER_DISPLAY_NAME_MAX_LENGTH
  );
};
